import React from 'react';
import { Box, Typography } from '@mui/material';
import Profile from '../../Profile/components/Profile';
import AboutMe from '../../Profile/components/AboutMe';

const ProfileTab = () => {
  return (
    <Box sx={{ p: 2, pb: 0, border: 0, height: 'calc(100vh - 270px)' }}>
      {/* <Profile /> */}
      <AboutMe />
    </Box>
  );
};

export default ProfileTab;
